import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { GET } from "../../services/axios.service";
import { SampleProps } from "../../types/sample";

export interface SampleDetailsState {
  sample: SampleProps;
  loading: boolean;
  error: string | null;
}

const initialState: SampleDetailsState = {
  sample: {} as SampleProps,
  loading: false,
  error: null,
};

export const fetchSampleDetailsData = createAsyncThunk(
  "fetchSampleDetailsData",
  async (req: { sampleId: number }) => {
    let response: any;
    await GET(`/v1/worker/samples/${req.sampleId}`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const sampleDetailsSlice = createSlice({
  name: "sampleDetails",
  initialState,
  reducers: {
    updateSampleDetails: (state, action: PayloadAction<SampleProps>) => {
      state.sample = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSampleDetailsData.pending, (state, action: any) => {
      state.sample = {} as SampleProps;
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchSampleDetailsData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.sample = action.payload.data.data;
        state.error = null;
      } else {
        state.sample = {} as SampleProps;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchSampleDetailsData.rejected, (state, action: any) => {
      state.sample = {} as SampleProps;
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { updateSampleDetails } = sampleDetailsSlice.actions;

export const getSampleDetails = (state: RootState) =>
  state.sampleDetails.sample;

export default sampleDetailsSlice.reducer;
